'use strict';

import Matricula from './matricula/matricula.promueve.module';
import Tramite from './tramite/tramite.promueve.module';
import Certificacion from './certificacion/certificacion.promueve.module';
import Autorizacion from './autorizacion/certificacion.promueve.module';
import Bandeja from './bandeja/bandeja.promueve.module';
import BandejaCertificaciones from './bandejaCertificaciones/bandeja.cert.promueve.module';
import Solicitud from './solicitud/solicitud.promueve.module';

const Empresario = angular
    .module('app.promueve.empresario', [
        Matricula,
        Tramite,
        Certificacion,
        Autorizacion,
        Bandeja,
        Solicitud,
        BandejaCertificaciones
    ])
    .name;

export default Empresario;



// WEBPACK FOOTER //
// ./src/app/components/promueve/empresario/empresario.module.js